<script lang="ts">
	import { attrs } from '#library/attrs.ts'
	import type { Blok, Heading } from '#library/components.schema.build.ts'
	import Render from '#components/render.svelte'
	import Link from '#components/link.svelte'

	interface Props {
		blok: Blok<Heading>
	}

	let { blok }: Props = $props()
</script>

<section class="heading {blok.theme}" {...attrs(blok)}>
	<div class="contain">
		{#if blok.title?.text}
			<svelte:element this={blok.title.tag || 'div'} class="title">
				{blok.title.text}
			</svelte:element>
		{/if}
		{#if blok?.body}
			<div class="body">
				<Render content={blok.body} />
			</div>
		{/if}
		{#if blok.link?.url}
			<div class="link">
				<Link href={blok.link.url} text={blok.link.text} target={blok.link.target} />
			</div>
		{/if}
	</div>
</section>

<style lang="css">
	.heading {
		background-color: var(--c-background);
		color: var(--c-foreground);
		padding-block: var(--padding-top, var(--padding-default)) var(--padding-bottom, var(--padding-default));
	}

	.contain {
		display: grid;
		gap: 0.5rem 2.5rem;

		@media (--from-mobile) {
			/* grid-template-columns: 7fr 1fr 4fr; 👀 Keep an eye on this */
			grid-template-columns: minmax(0, 8fr) minmax(0, 4fr);
		}
	}

	.title {
		font: 600 var(--f-h2);
		grid-column: 1;
		letter-spacing: var(--ls-h2);
		text-wrap: balance;
	}

	.body {
		color: var(--c-midground);
		font: 400 var(--f-body1);
		letter-spacing: var(--ls-body1);

		@media (--from-mobile) {
			grid-column: 1;
		}
	}

	.link {
		@media (--from-mobile) {
			grid-column: 3;
			grid-row: 1;
		}
	}
</style>
